let Loading = Vue.component('loading', {
	data() {
		return {
			currentDots: '...',
			dotIndex: 0
		}
	},
	methods: {
		loadingDots() {
			let dots = ['.', '..', '...']
			this.currentDots = dots[this.dotIndex]
		}
	},
	mounted() {
		setInterval(() => {
			this.dotIndex++
			if (this.dotIndex >= 3) this.dotIndex = 0
			this.loadingDots()
		}, 300);
	},
	computed: {
		cursorClass: function() {
			if (this.$root.$store.state.loadingOptions.cursor == 'circle') {
				return 'circle'
			} else {
				return 'internal'
			}
		},
		color: function() {
			return this.$root.$store.state.loadingOptions.color
		},
		show: function() {
			return this.$root.$store.state.loadingOptions.show
		}
	},
	template: `
		<header v-show="this.show" v-bind:style="{ color: this.color }" v-bind:class="this.cursorClass" class="loading">
		  <h1 class="loading-dots">{{ this.currentDots }}</h1>
		</header>`
})

export default Loading
